import axios from 'axios'
import { put, call, takeLatest } from 'redux-saga/effects'

import apiConfig from '@services/apiConfig'

import { GET_AUTH, setAuth } from '@actions/auth'
import errorHandler from '../errorHandler'

function* getAuth({ callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix}/auth-data`,
    })
    yield put(setAuth(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

export function* getAuthSaga() {
  yield takeLatest(GET_AUTH, getAuth)
}
